<template>
  <div class="basic-setting-container custom-success-input">
    <div class="basic-setting-body">
      <div class="content">
        <el-form ref="settingForm" class="setting-form" label-position="left" :model="form" label-width="110px" @submit.native.prevent :rules="formRules">
          <el-form-item label="系统名称" prop="applicationName">
            <el-input v-model="form.applicationName"></el-input>
          </el-form-item>
          <el-form-item label="系统LOGO">
            <div class="upload-content">
              <el-upload
                class="upload-demo"
                action=""
                :http-request="uploadFile"
                :before-upload="beforeAvatarUpload"
                :data="{type: 'logo'}"
                name="image"
              >
                <div class="upload-click">
                  <img :src="form.logo ? getDownLoadUrl(form.logo) : logo" alt="图片已失效">
                </div>
                <div class="upload-btn">
                  <el-button icon="el-icon-plus" type="text">上传图片</el-button>
                </div>
                <div class="el-upload__tip" slot="tip">建议尺寸:128*128px</div>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="登录页背景">
            <div class="upload-content">
              <el-upload
                class="upload-demo"
                action=""
                :http-request="uploadFile"
                :before-upload="beforeAvatarUpload"
                name="image"
                :data="{type: 'backgrounds'}"
              >
                <div class="upload-backfround-click">
                  <img :src="form.backgrounds ? getDownLoadUrl(form.backgrounds) : defaultBg" alt="图片已失效">
                </div>
                <div class="upload-btn upload-bg">
                  <el-button icon="el-icon-plus" type="text">上传图片</el-button>
                </div>
                <div class="choose-bg" @click.stop="appearBg">选择背景</div>
                <div class="el-upload__tip" slot="tip">建议尺寸:1920*1080px</div>
              </el-upload>
              <div class="backgrounds" v-if="bgVisiable" @mouseleave="bgVisiable=false">
                  <span class="bg" :class="{'active':selectActive===index}" v-for="(bg,index) in backgrounds" :key="index" @click="chooseBackground(index,bg.link)">
                     <img :src="bg.link" :alt="bg.link" >
                  </span>
                </div>
            </div>
          </el-form-item>
          <el-form-item label="域名" prop="domain">
            <label>{{form.domain}}</label>
          </el-form-item>
          <el-form-item label="短信签名" prop="signature">
            <el-input v-model="form.signature" placeholder=""></el-input>
          </el-form-item>
          <el-form-item class="login-types" label="PC登录方式">
            <el-radio-group v-model="form.pcLoginModel">
              <el-radio label="qrcode">二维码</el-radio>
              <el-radio label="account">账号密码</el-radio>
              <el-radio label="both">二维码/账号密码</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="APP登录方式">
            <el-radio-group v-model="form.appLoginModel">
              <el-radio label="account">账号密码登录</el-radio>
              <el-radio label="phone">手机验证码登录</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="APP高级安全">
            <el-tooltip content="若开启，则在用户登录APP时，要求人脸验证。" placement="top" class="tooltip">
              <span class="fa fa-question-circle"></span>
            </el-tooltip>
            <el-switch v-model="form.appSecurity"></el-switch>
          </el-form-item>
          <el-form-item class="save text-center">
            <el-button class="save-btn" type="primary" @click="updateSystemInfo">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { ossMixin } from '@/components/form/runtime/components/mixins.js'

export default {
  name: 'basicSetting',
  mixins: [ossMixin],
  data () {
    let maxLength = (rule, value, callback) => {
      if (value.length > 50) {
        callback(new Error('文本框限制只可输入50个字符'))
      }
      callback()
    }

    return {
      backgrounds,
      defaultBg,
      logo,
      form: {
        applicationName: '',
        backgrounds: '',
        domain: '',
        logo: '',
        pcLoginModel: 'account',
        appLoginModel: 'account',
        appSecurity: false,
        signature: ''
      },
      formRules: {
        applicationName: [{ required: true, message: '系统名称不可为空', trigger: 'blur' }, {validator: maxLength, trigger: 'blur'}],
        domain: [{ required: true, message: '请输入域名', trigger: 'blur' }, {validator: maxLength, trigger: 'blur'}],
        signature: [{max: 10, message: '短信签名最多输入10个字符', trigger: 'blur'}]
      },
      // headers: '',
      // 应用id
      applicationId: '',
      bgVisiable: false,
      selectActive: -1
      // uploadUrl: `${process.env.UPLOAD_URL}/api/upload-image`
    }
  },
  created () {
    this.getSystemInfo()
    // this.headers = {
    //   Authorization: tokenStorage.getToken()
    // }
  },
  methods: {
    appearBg () {
      this.bgVisiable = true
    },
    uploadFile (files) {
      let file = files.file
      let key = this.getOssKey('SYSTEM', file.name)
      let url = sessionStorage.getItem('ossDownloadUrl')
      let formData = this.getUploadFormData(key, file)
      this.$axios.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
        if (res.status === 200) {
          if (files.data.type === 'logo') {
            this.successUpload(this.getResult(key, file.name))
          } else if (files.data.type === 'backgrounds') {
            this.successBackgroundsUpload(this.getResult(key, file.name))
          }
        }
      })
    },
    // 限制上传文件大小和格式
    beforeAvatarUpload (file) {
      let type = file.type
      let result = true
      if (type !== 'image/jpeg' && type !== 'image/png') {
        this.$message.error('上传头像图片只能是 jpg 或 png 格式!')
        result = false
      } else {
        if (file.size / 1024 / 1024 > 2) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          result = false
        }
      }
      return result
    },
    // 上传成功，获取路径
    successUpload (res) {
      this.form.logo = res[0].result.dir
    },
    successBackgroundsUpload (res) {
      this.form.backgrounds = res[0].result.dir
    },
    // 修改系统信息
    updateSystemInfo () {
      this.$refs.settingForm.validate(validator => {
        if (validator) {
          let params = {
            id: this.applicationId,
            logo: this.form.logo,
            backgrounds: this.form.backgrounds,
            applicationName: this.form.applicationName,
            domain: this.form.domain,
            pcLoginModel: this.form.pcLoginModel,
            appLoginModel: this.form.appLoginModel,
            appSecurity: this.form.appSecurity,
            signature: this.form.signature
          }
          this.$axios.post(`/system-api/application`, params).then(res => {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            document.title = this.form.applicationName
          })
        } else {
          return false
        }
      })
    },
    // 获取系统信息
    getSystemInfo () {
      this.$axios.get(`/system-api/application`).then(res => {
        this.$_.merge(this.form, res.data.data)
        this.applicationId = res.data.data.id
      })
    },
    chooseBackground (index, background) {
      this.selectActive = index
      this.form.backgrounds = background
    },
    getDownLoadUrl (path) {
      // 本地文件直接访问项目部署的静态资源目录
      if (path.includes('static')) {
        return path
      } else {
        return sessionStorage.getItem('ossDownloadUrl') + path
      }
    }
  }
}
const backgrounds = [
  {link: require('../assets/保险.png'), title: '保险'},
  {link: require('../assets/医疗.png'), title: '医疗'},
  {link: require('../assets/商务.png'), title: '商务'},
  {link: require('../assets/教育.png'), title: '教育'},
  {link: require('../assets/旅游.png'), title: '旅游'},
  {link: require('../assets/科技.png'), title: '科技'},
  {link: require('../assets/餐饮.png'), title: '餐饮'},
  {link: require('../assets/汽车.png'), title: '汽车'},
  {link: require('../assets/default.png'), title: '默认'},
  {link: require('../assets/newTenant.png'), title: '新租户默认'}
]
const logo = require('../assets/redcat.png')
const defaultBg = require('../assets/default.png')
</script>

<style lang="scss">
  .basic-setting-container {
    padding: 10px;
    height: 100%;

    .basic-setting-body {
      background:#fff;
      box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
      border-radius: 4px 0;
      height: 100%;
      overflow: auto;

      // 修改elementUI样式
      .el-form-item__label {
        padding-right: 25px;
        color: #232323;
        font-size: 12px;
      }

      .el-upload__tip {
        padding: 0;
        color: #A3A2A2;
        font-size: 12px;
        margin-top: -2px;
      }

      // 不让上传成功之后显示文件列表
      .el-upload-list__item-name,
      .el-progress,
      .el-progress--line,
      .el-upload-list,
      .el-upload-list--text {
        display: none;
      }

      .text-center {
        text-align: center;
      }

      .content {
        width: 400px;
        margin: 0 auto;
        padding-top: 28px;
        height: 100%;

        .setting-form {
          height: 100%;
          .login-types {
            width: 500px;
          }
        }

        .upload-content {
          width: 280px;
          height: 210px;
          border: 1px solid #edf2f5;
          text-align: center;
          padding-top: 14px;
          position: relative;

          .upload-btn {
            padding-top: 6px;
            color: #54ABF1;
            font-size: 12px;
            &.upload-bg {
              text-align: left;
              margin-left: 48px;
            }

            .el-icon-plus {
              font-size: 12px;
            }

            button {
              span {
                font-size: 12px;
              }
            }
           }
           .choose-bg {
            position: absolute;
            right: 76px;
            bottom: 32px;
            font-size: 12px;
            color: var(--primary, #409EFF);
            &::before {
             content: '';
              width: 1px;
              height: 12px;
              background: #C3CCDC;
              display: block;
              top: 8px;
              left: -12px;
              position: absolute;
            }
          }
          .backgrounds {
            width:276px;
            height:164px;
            background:rgba(255,255,255,1);
            box-shadow:0px 0px 6px 0px rgba(19,73,135,0.09);
            border-radius:4px;
            overflow-y: auto;
            padding: 11px 16px;
            position: absolute;
            right: -210px;
            bottom: -124px;
            z-index: 5;

            .bg {
              width:110px;
              height:64px;
              background:rgba(239,247,253,1);
              display: inline-block;
              border:1px solid transparent;
              float: left;
              &:nth-child(2n+1){
                margin-right: 12px
              }
              &.active {
                border:2px solid var(--primary, #54ABF1);
              }
              img {
                width:106px;
                height:60px;
                display: inline-block;

              }
           }
          }
          .upload-click,.upload-backfround-click {
            width: 128px;
            height: 128px;
            line-height: 150px;
            background:rgba(239,247,253,1);
            margin: 0 auto;
            overflow: hidden;
            img {
              width:96%;
              margin: 0 auto;
            }
          }
          .upload-backfround-click {
            width: 236px;
            height: 128px;
            background: #fff;
            img {
              height: 100%;
              width: 100%;
            }

          }
        }
        .save {
          padding-top: 20px;

          .save-btn {
            padding-left: 24px;
            padding-right: 24px;
          }
        }
      }
    }
  }
  @import "@/assets/scss/common.scss";
</style>



// WEBPACK FOOTER //
// src/components/system/system/basic-setting.vue